export default "__VITE_ASSET__cxNWaDac__"